import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {IRole} from "@models/roles/roles.ts";
import {TableCell, TableRow} from "@mui/material";
import {useRolesOld} from "@components/roles/hooks/useRolesOld.ts";
import {useEffect, useState} from "react";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";
import {UsuarioTypo} from "@components/usuario/UsuarioTypo.tsx";

interface RoleInfoRowProps extends DefaultInfoV1Props<IRole> {
}

export function RoleInfoRow(props: RoleInfoRowProps) {
    const {EndComponent} = props
    const {getRole} = useRolesOld()
    const [value, setValue] = useState<IRole | undefined>(props.value)

    useEffect(() => {
        if (value == null && props.expectedId != null && props.expectedId > 0) {
            getRole(props.expectedId).then(x => {
                setValue(x)
            })
        }
    }, [value]);

    return (value != null &&
        <TableRow>
            <TableCell>{value.id}</TableCell>
            <TableCell>{value.nome}</TableCell>
            <TableCell>{value.descricao}</TableCell>
            <TableCell>{ToDateTimeDefault(value.dataCriacao)}</TableCell>
            <TableCell><UsuarioTypo usuarioId={value.usuarioCriacaoId}
                                    typographyProps={{fontSize: 'smaller'}}/>
            </TableCell>
            <TableCell>{EndComponent && <EndComponent {...value}/>}</TableCell>

        </TableRow>
    )
}